import React from 'react';
import { motion } from 'framer-motion';

const FuturisticLogo = ({ size = 40, className = "" }) => {
  const primaryColor = "#7c3aed";
  const secondaryColor = "rgba(0, 0, 0, 0.1)";
  const accentColor = "#5AC8FA";

  return (
    <div
      className={className}
      style={{ width: size, height: size, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <svg viewBox="0 0 100 100" style={{ width: '100%', height: '100%', overflow: 'visible' }}>
        <defs>
          <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2.5" result="blur" />
            <feComposite in="SourceGraphic" in2="blur" operator="over" />
          </filter>
        </defs>

        <motion.circle
          cx="50" cy="50" r="45" fill="none" stroke={secondaryColor} strokeWidth="1"
          strokeDasharray="10 5" opacity="0.2"
          animate={{ rotate: 360 }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
          style={{ transformOrigin: '50px 50px' }}
        />

        <motion.circle
          cx="50" cy="50" r="35" fill="none" stroke={primaryColor} strokeWidth="1.5"
          strokeDasharray="20 10" filter="url(#glow)"
          animate={{ rotate: -360, opacity: [0.3, 0.6, 0.3] }}
          transition={{
            rotate: { duration: 15, repeat: Infinity, ease: "linear" },
            opacity: { duration: 3, repeat: Infinity, ease: "easeInOut" }
          }}
          style={{ transformOrigin: '50px 50px' }}
        />

        <motion.circle
          cx="50" cy="50" r="25" fill="none" stroke={accentColor} strokeWidth="2"
          strokeDasharray="5 5" opacity="0.5"
          animate={{ rotate: 360 }}
          transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
          style={{ transformOrigin: '50px 50px' }}
        />

        <motion.text
          x="50" y="58" textAnchor="middle" fill={primaryColor} fontSize="32" fontWeight="700"
          fontFamily="Inter, sans-serif" style={{ pointerEvents: 'none' }}
          animate={{ scale: [1, 1.05, 1], opacity: [0.8, 1, 0.8] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        >
          m
        </motion.text>
      </svg>
    </div>
  );
};

export default FuturisticLogo;
